module.exports = __webpack_public_path__ + "img/aurora-front-angle.8b0529dc.png";